import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import styled, { keyframes } from 'styled-components';
import { useNavigate } from 'react-router-dom';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const NotFoundIllustration = () => (
  <svg width="180" height="150" viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="100" cy="80" r="50" fill="#F3F4F6" />
    <path d="M100 40C77.9086 40 60 57.9086 60 80C60 102.091 77.9086 120 100 120C122.091 120 140 102.091 140 80C140 57.9086 122.091 40 100 40Z" stroke="#E5E7EB" strokeWidth="4"/>
    <path d="M135 115L160 140" stroke="#E5E7EB" strokeWidth="8" strokeLinecap="round"/>
    <path d="M85 75L115 105" stroke="#EF4444" strokeWidth="4" strokeLinecap="round"/>
    <path d="M115 75L85 105" stroke="#EF4444" strokeWidth="4" strokeLinecap="round"/>
    <circle cx="100" cy="50" r="3" fill="#9CA3AF"/>
    <rect x="50" y="130" width="100" height="8" rx="4" fill="#E5E7EB" />
  </svg>
);

const OriginadorNaoEncontrado = () => {
  const navigate = useNavigate();

  return (
    <>
      <BackgroundBlur />
      <Container fluid className="d-flex justify-content-center align-items-center vh-100">
        <Row className="w-100 justify-content-center">
          <Col md={8} lg={5}>
            <ErrorCard>
              <IllustrationWrapper>
                <NotFoundIllustration />
              </IllustrationWrapper>
              
              <Title>Acesso Negado</Title>

              <HelpText>
                Verifique se o link (URL) está correto ou entre em contato com o suporte técnico.
              </HelpText>

            </ErrorCard>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default OriginadorNaoEncontrado;

const BackgroundBlur = styled.div`
  background-image: url('/imgBackGround.webp');
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  filter: blur(8px) grayscale(30%);
  opacity: 0.5;
`;

const ErrorCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  padding: 3.5rem 2rem;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: ${fadeIn} 0.6s ease-out;
  border: 1px solid rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
`;

const IllustrationWrapper = styled.div`
  margin-bottom: 24px;
  opacity: 0.9;
`;

const Title = styled.h2`
  color: #1F2937;
  font-weight: 700;
  font-size: 1.75rem;
  margin-bottom: 16px;
  font-family: 'Segoe UI', sans-serif;
`;

const Description = styled.p`
  color: #4B5563;
  font-size: 1.1rem;
  line-height: 1.6;
  max-width: 90%;
  margin-bottom: 8px;
`;

const HelpText = styled.p`
  color: #9CA3AF;
  font-size: 0.9rem;
  margin-bottom: 32px;
`;

const BaseButton = (props: any) => <Button {...props} />;

const ActionButton = styled(BaseButton)`
  padding: 12px 32px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.2s ease;
  background-color: #2563EB;
  border: none;
  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 10px -1px rgba(37, 99, 235, 0.3);
    background-color: #1D4ED8;
  }

  &:active {
    transform: translateY(0);
  }
`;